import React, { useState ,useEffect} from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Pagination, PaginationItem, Box
} from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useGetReferralBonusQuery,useGetReferralCommissionQuery } from "../../features/api/userApiSlice";
import { format } from 'date-fns';

const RecordTable = ({ value, startDate, endDate, status  }) => {
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;
  const { t } = useTranslation();
  const isReferral = value === "referral";
  const statusChosen = status === "all";

  const handlePageChange = (_, value) => {
    setPage(value);
  };

  const queryParams = { startDate, endDate };

  const { 
    data: referralData, 
    error, 
    isLoading,
    isFetching 
  } = useGetReferralBonusQuery(queryParams);

  const { 
    data: referralCommission, 
    errorReferralCommission, 
    isReferralCommissionLoading,
    isReferralCommissionFetching 
  } = useGetReferralCommissionQuery(queryParams);

  const referralApiResult = referralData?.result || [];
  const nonNullReferralApiData = referralApiResult.filter(apiItem => apiItem.date !== null);

  const referralCommissionResult = referralCommission?.result || [];
  const nonNullReferralCommissionApiData = referralCommissionResult.filter(apiItem => apiItem.date !== null);

const formattedReferralData = nonNullReferralApiData.map(apiItem => ({

  date: format(new Date(apiItem.date), 'dd-MM-yyyy'),
  username: apiItem.downlineUsername,
  bonusAmount: apiItem.bonusAmount,
  validTurnoverAmount: apiItem.validTurnoverAmount,
  requiredTurnover: apiItem.requiredTurnover,
  status: apiItem.status,
}));

const formattedCommissionData = nonNullReferralCommissionApiData.map(apiItem => ({

  date: format(new Date(apiItem.date), 'dd-MM-yyyy'),
  directValidDeposit: apiItem.directValidDeposit,
  directTeamDeposit: apiItem.directTeamDeposit,
  directValidBet: apiItem.directValidBet,
  teamValidBet: apiItem.teamValidBet,
  totalCommission: apiItem.totalCommission,
}));

  //   useEffect(() => {
  //  
  //   if (!isReferralCommissionLoading) {
  //     if (errorReferralCommission) {   
  //       console.error(' API call failed:', errorReferralCommission);
  //     } else if (referralCommission) {   
  //       console.log('API call successful! Data:', referralCommission);
  //     } 
  //   }
  // }, [referralCommission, errorReferralCommission, isReferralCommissionLoading]);

  if (isLoading) {
    return <div>Loading bonus data...</div>;
  }

  //
  const tableData =
    value === "commission"
      ? formattedCommissionData
      : formattedReferralData;

const filteredData =

  (value === "commission" || status === "ALL")
    ? tableData
    : tableData.filter(item => item.status === status);

  const pageCount = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );


  const summary =
    value === "commission"
      ? paginatedData.reduce(
        (acc, row) => ({
          directValidDeposit: acc.directValidDeposit + (row.directValidDeposit || 0),
          directTeamDeposit: acc.directTeamDeposit + (row.directTeamDeposit || 0),
          directValidBet: acc.directValidBet + (row.directValidBet || 0),
          teamValidBet: acc.teamValidBet + (row.teamValidBet || 0),
          totalCommission: acc.totalCommission + (row.totalCommission || 0),
        }),
        { directValidDeposit: 0, directTeamDeposit: 0, directValidBet: 0, teamValidBet: 0, totalCommission: 0  }
        )
      : paginatedData.reduce(
          (acc, row) => ({
            bonusAmount: acc.bonusAmount + (row.bonusAmount || 0),
            validTurnoverAmount: acc.validTurnoverAmount + (row.validTurnoverAmount || 0),
            requiredTurnover: acc.requiredTurnover + (row.requiredTurnover || 0),
          }),
          { bonusAmount: 0, validTurnoverAmount: 0, requiredTurnover: 0}
        );

   return (
    <Paper sx={{ backgroundColor: "white", mt: 4 }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {isReferral ? (
                <>
                  <TableCell><strong>{t("referral.date")}</strong></TableCell>
                  <TableCell><strong>{t("referral.username")}</strong></TableCell>
                  <TableCell align="center"><strong>{t("referral.bonusamount")}</strong></TableCell>
                  <TableCell align="center"><strong>{t("referral.requiredturnover")}</strong></TableCell>
                  <TableCell align="center"><strong>{t("referral.validturnover")}</strong></TableCell>
                   <TableCell><strong>{t("referral.status")}</strong></TableCell>
                </>
              ) : (
                <>
                <TableCell><strong>{t("referral.commgeneratedate")}</strong></TableCell>
                <TableCell align="center"><strong>{t("referral.directvaliddeposit")}</strong></TableCell>
                <TableCell align="center"><strong>{t("referral.directteamdeposit")}</strong></TableCell>
                <TableCell align="center"><strong>{t("referral.directvalidbet")}</strong></TableCell>
                <TableCell align="center"><strong>{t("referral.teamvalidbet")}</strong></TableCell>
                <TableCell align="center"><strong>{t("referral.totalcommission")}</strong></TableCell>
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={isReferral ? 6 : 4} align="center">
                  {t("referral.norecords")}
                </TableCell>
              </TableRow>
            ) : (
              <>
                {paginatedData.map((row, idx) => (
                  <TableRow key={idx}>
                  {isReferral ? (
                        <>
                          <TableCell>{row.date}</TableCell>
                          <TableCell>{row.username}</TableCell>
                          <TableCell align="center">{(row.bonusAmount ?? 0).toLocaleString()}</TableCell>
                          <TableCell align="center">{(row.validTurnoverAmount ?? 0).toLocaleString()}</TableCell>
                          <TableCell align="center">{(row.requiredTurnover ?? 0).toLocaleString()}</TableCell>
                          <TableCell>{row.status}</TableCell>
                        </>
                      ) : (
                        <>
                          <TableCell>{row.date}</TableCell>
                          <TableCell align="center">{(row.directValidDeposit ?? 0).toLocaleString()}</TableCell>
                          <TableCell align="center">{(row.directTeamDeposit ?? 0).toLocaleString()}</TableCell>
                          <TableCell align="center">{(row.directValidBet ?? 0).toLocaleString()}</TableCell>
                          <TableCell align="center">{(row.teamValidBet ?? 0).toLocaleString()}</TableCell>
                          <TableCell align="center">{(row.totalCommission ?? 0).toLocaleString()}</TableCell>
                        </>
                      )}
                  </TableRow>
                ))}
                <TableRow>
                  
                  {isReferral ? (
                    <>
                      <TableCell colSpan={2}><strong>{t("referral.total")}</strong></TableCell>
                      <TableCell align="center"><strong>{summary.bonusAmount.toLocaleString()}</strong></TableCell>
                      <TableCell align="center"><strong>{summary.validTurnoverAmount.toLocaleString()}</strong></TableCell>
                      <TableCell align="center"><strong>{summary.requiredTurnover.toLocaleString()}</strong></TableCell>
                    </>
                  ) : (
                    <>
                    <TableCell colSpan={1}><strong>{t("referral.total")}</strong></TableCell>
                      <TableCell align="center"><strong>{summary.directValidDeposit.toLocaleString()}</strong></TableCell>
                      <TableCell align="center"><strong>{summary.directTeamDeposit.toLocaleString()}</strong></TableCell>
                      <TableCell align="center"><strong>{summary.directValidBet.toLocaleString()}</strong></TableCell>
                      <TableCell align="center"><strong>{summary.teamValidBet.toLocaleString()}</strong></TableCell>
                      <TableCell align="center"><strong>{summary.totalCommission.toLocaleString()}</strong></TableCell>
                      <TableCell />
                    </>
                  )}
                  <TableCell />
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination controls */}
      <Box display="flex" justifyContent="flex-end" py={2} pr={2}>
        <Pagination
          count={pageCount}
          page={page}
          onChange={handlePageChange}
          color="primary"
          siblingCount={1}
          boundaryCount={1}
          renderItem={(item) => (
            <PaginationItem
              {...item}
              components={{ previous: ArrowBack, next: ArrowForward }}
              sx={{ '& svg': { color: 'black' } }}
            />
          )}
        />
      </Box>
    </Paper>
  );
};

export default RecordTable;
